var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDropdown(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "fi-sr-caret-down"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M6.41385 9H17.5858C17.7836 9.00004 17.9769 9.05871 18.1413 9.1686C18.3057 9.27848 18.4339 9.43465 18.5095 9.61734C18.5852 9.80004 18.605 10.0011 18.5664 10.195C18.5279 10.389 18.4327 10.5671 18.2928 10.707L12.7068 16.293C12.5193 16.4805 12.265 16.5858 11.9998 16.5858C11.7347 16.5858 11.4804 16.4805 11.2928 16.293L5.70685 10.707C5.56704 10.5671 5.47183 10.389 5.43327 10.195C5.3947 10.0011 5.4145 9.80004 5.49017 9.61734C5.56584 9.43465 5.69398 9.27848 5.85839 9.1686C6.0228 9.05871 6.2161 9.00004 6.41385 9Z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDropdown);
export default __webpack_public_path__ + "static/media/dropdown.768dc7025f5cce81460ff4629f69fdca.svg";
export { ForwardRef as ReactComponent };